import { FC, useState } from 'react';
import { SidePanel } from 'src/components/sidePanel/SidePanel';
import {
  IRuleValidation,
  useGetRuleValidationsByFieldNameQuery,
  useGetRuleValidationsQuery,
} from '../../../redux/services/settings';
import { EditRuleValidation } from './EditRuleValidation';
import { RuleValidation } from './RuleValidation';

interface IEditRuleValidations {
  isOpen: boolean;
  fieldName: string;
  onClose: () => void;
  isNoBackdrop?: boolean;
}

export const EditRuleValidations: FC<IEditRuleValidations> = ({ isOpen, fieldName, onClose, isNoBackdrop = true }) => {
  const [ruleValidationModalOpen, setRuleValidationModalOpen] = useState(false);
  const [ruleValidationField, setRuleValidationField] = useState<IRuleValidation | undefined>(
    undefined,
  );

  const { data: ruleValidations = [] } = useGetRuleValidationsQuery();
  const { data: ruleValidationsField = [] } = useGetRuleValidationsByFieldNameQuery(fieldName);

  return (
    <>
      <SidePanel
        onClose={onClose}
        isOpen={isOpen}
        title={`Настройка правил валидации для '${fieldName}'`}
        description="Выберите правила валидации, которые хотите применить для поля:"
        AdditionalAction={() => setRuleValidationModalOpen(true)}
        isNoBackdrop={isNoBackdrop}
      >
        <div>
          {ruleValidations.map((ruleValidation) => (
            <RuleValidation
              key={ruleValidation.id}
              rule={ruleValidation}
              onEdit={() => {
                setRuleValidationField(ruleValidation);
                setRuleValidationModalOpen(true);
              }}
              checked={!!ruleValidationsField.find((f) => f.id === ruleValidation.id)}
              fieldName={fieldName}
            />
          ))}
        </div>
      </SidePanel>
      <EditRuleValidation
        isOpen={ruleValidationModalOpen}
        onClose={() => {
          setRuleValidationField(undefined);
          setRuleValidationModalOpen(false);
        }}
        selectedRuleValidation={ruleValidationField}
      />
    </>
  );
};
